import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/site/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Not Found — L F Building" description="This page could not be found." path="/404" />
      <section className="min-h-[70vh] grid place-items-center bg-white">
        <div className="container-lf text-center py-24">
          <div className="font-display font-bold text-brand text-[160px] md:text-[240px] leading-none">404</div>
          <h1 className="font-display font-bold uppercase text-4xl md:text-6xl">Page not found.</h1>
          <p className="text-neutral-600 mt-4 max-w-md mx-auto">The page you were looking for has been moved, renamed, or never existed. Let's get you back on track.</p>
          <Link to="/" className="inline-block mt-8">
            <Button className="rounded-none bg-brand hover:bg-brand-hover text-white h-12 px-8 uppercase tracking-wider text-sm font-semibold">
              Back to Home <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </section>
    </>
  );
}
